import { Directive, ElementRef, InjectionToken, Input, inject } from '@angular/core';

export const TruncateLimit = new InjectionToken<number>('TruncateLimit');

@Directive({
  selector: '[appTruncate]',
  standalone: true
})
export class TruncateDirective {

 
  @Input() limit = inject(TruncateLimit, {optional: true})  // ?? 80;
  private readonly elRef = inject(ElementRef);

  ngAfterViewInit() {
    const text = this.elRef.nativeElement?.textContent?.trim() || '';
  
    const limit = this.limit ?? 24; 
  
    if (text.length > limit) {this.elRef.nativeElement.textContent = `${text.slice(0, limit - 3)}...`;
    } 
    else {
      this.elRef.nativeElement.textContent = text;
    }
  }
  
  
}
